<script setup lang="ts">
import type { TAllergenCode } from './regulatory-declarations.types';

defineProps<{
  code: TAllergenCode;
}>();
</script>

<template>
  <svg
    class="alrg-ic"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="code === 'GLUTEN'">
      <path d="M12 22V9" />
      <path d="M12 9c0-3-2-5-5-5-.4 3 1.6 5 5 5Z" />
      <path d="M12 9c0-3 2-5 5-5 .4 3-1.6 5-5 5Z" />
      <path d="M12 14c0-3-2-5-5-5-.4 3 1.6 5 5 5Z" />
      <path d="M12 14c0-3 2-5 5-5 .4 3-1.6 5-5 5Z" />
    </template>
    <template v-else-if="code === 'CRUSTACEANS'">
      <path d="M17 6c-5 0-9 3.5-9 8a3.5 3.5 0 0 0 6.6 1.6" />
      <path d="M17 6c1.7 0 3 1 3.3 2.6" />
      <path d="M8 14c-2.6.4-4.6-.7-5.6-3" />
      <path d="M8.4 15.6c-2.3 1-4.4.9-6.4-.4" />
      <path d="M9 17.2c-1.8 1.2-2.8 2.7-3 4.3" />
    </template>
    <template v-else-if="code === 'EGGS'">
      <path
        d="M12 22c6.2-.05 7.9-5.6 7.5-10C19.1 7.7 15.5 2 12 2 8.5 2 4.9 7.7 4.5 12c-.4 4.4 1.3 9.95 7.5 10Z"
      />
    </template>
    <template v-else-if="code === 'FISH'">
      <path d="M4 12c2.6-4.2 8.4-4.2 11 0-2.6 4.2-8.4 4.2-11 0Z" />
      <path
        d="M15 12c1.5-1.3 3.6-1.6 5.7-1-1 1.3-1 2.7 0 4-2.1.6-4.2.3-5.7-1"
      />
      <path d="M7.5 11h.01" />
    </template>
    <template v-else-if="code === 'PEANUTS'">
      <path
        d="M12 3a3 3 0 0 0-3 3c0 1.6-2 2.6-2 5s2 3.4 2 5a3 3 0 0 0 6 0c0-1.6 2-2.6 2-5s-2-3.4-2-5a3 3 0 0 0-3-3Z"
      />
      <path d="M9.2 11.3c1.3.9 4.3.9 5.6 0" />
    </template>
    <template v-else-if="code === 'SOYBEANS'">
      <path d="M5 19C3 15 6.5 5 15 5c2.2 4.2-1.7 14-10 14Z" />
      <circle cx="8.5" cy="13.6" r="1.3" />
      <circle cx="10.8" cy="10.5" r="1.3" />
      <circle cx="12.9" cy="7.9" r="1.1" />
    </template>
    <template v-else-if="code === 'MILK'">
      <path d="M8 2h8" />
      <path
        d="M9 2v2.8a4 4 0 0 1-.7 2.2l-.6 1A4 4 0 0 0 7 10.2V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.8a4 4 0 0 0-.7-2.2l-.6-1A4 4 0 0 1 15 4.8V2"
      />
      <path d="M7 15a6.5 6.5 0 0 1 5 0 6.5 6.5 0 0 0 5 0" />
    </template>
    <template v-else-if="code === 'NUTS'">
      <path d="M6 8c0-3 2.7-5 6-5s6 2 6 5H6Z" />
      <path d="M6 8c0 5.5 3 9.5 6 11 3-1.5 6-5.5 6-11" />
      <path d="M12 3V2" />
    </template>
    <template v-else-if="code === 'CELERY'">
      <path
        d="M8.5 21c0-5 .4-9 .9-11M12 21c0-6 0-10 0-12M15.5 21c0-5-.4-9-.9-11"
      />
      <path
        d="M12 9c-2.2-1-3.5-3-3.5-5.2C10.7 3.8 12 5 12 6.5 12 5 13.3 3.8 15.5 3.8 15.5 6 14.2 8 12 9Z"
      />
      <path d="M8 21h8" />
    </template>
    <template v-else-if="code === 'MUSTARD'">
      <path d="M9 8h6v11a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2Z" />
      <path d="M10 8V5h4v3" />
      <path d="M11 5V3h2v2" />
      <path d="M9 13h6" />
    </template>
    <template v-else-if="code === 'SESAME'">
      <path
        d="M6 8c1 0 1.8 1 1.8 2.3S7 12.6 6 12.6 4.2 11.6 4.2 10.3 5 8 6 8Z"
      />
      <path
        d="M12.5 4.6c1 0 1.8 1 1.8 2.3s-.8 2.3-1.8 2.3-1.8-1-1.8-2.3.8-2.3 1.8-2.3Z"
      />
      <path
        d="M13.5 13c1 0 1.8 1 1.8 2.3s-.8 2.3-1.8 2.3-1.8-1-1.8-2.3.8-2.3 1.8-2.3Z"
      />
      <path
        d="M18 8.6c1 0 1.8 1 1.8 2.3s-.8 2.3-1.8 2.3-1.8-1-1.8-2.3S17 8.6 18 8.6Z"
      />
    </template>
    <template v-else-if="code === 'SULPHITES'">
      <path d="M9 3h6" />
      <path d="M10 3v6l-5.2 8.3A2 2 0 0 0 6.5 21h11a2 2 0 0 0 1.7-3.1L14 9V3" />
      <path d="M7.5 15h9" />
    </template>
    <template v-else-if="code === 'LUPIN'">
      <path d="M12 21v-7" />
      <path d="M12 14c-2 0-3.4-1-3.4-2.5C10.6 11.5 12 12.5 12 14Z" />
      <path d="M12 14c2 0 3.4-1 3.4-2.5C13.4 11.5 12 12.5 12 14Z" />
      <path d="M12 11c-1.7 0-3-1-3-2.3C10.7 8.7 12 9.6 12 11Z" />
      <path d="M12 11c1.7 0 3-1 3-2.3C13.3 8.7 12 9.6 12 11Z" />
      <path d="M12 8.3c-1.4 0-2.4-.9-2.4-2C10.9 6.3 12 7.1 12 8.3Z" />
      <path d="M12 8.3c1.4 0 2.4-.9 2.4-2C13.1 6.3 12 7.1 12 8.3Z" />
    </template>
    <template v-else-if="code === 'MOLLUSCS'">
      <path d="M4 13a8 8 0 0 1 16 0c-2 2-5 3-8 3s-6-1-8-3Z" />
      <path d="M12 3.2v12.6" />
      <path d="M8.6 4 6.7 15.4" />
      <path d="M15.4 4 17.3 15.4" />
    </template>
  </svg>
</template>
